import { Box, Button, CardMedia, CircularProgress, Dialog, DialogContent, Grid, Hidden, IconButton, Skeleton, Tab, Tabs, Theme, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import CustomNavChart from '../../dashboard/chart/CustomNavChart';
import { AUMActiveIcon, BlueStarFilled, BorderStarFilled, DownwardNegativeIcon, ExitLoadIcon, GoldenStarFilled, InfoIconOutlined, KotakIcon, LumpsumSIPIcon, MutualFundsActiveIcon, UpWardPositiveIcon } from '../../../assets/SvgIcons';
import { checkImageExists, filterDataPointsForNav, findNextValidDate, formatCurrency, formatDate, getDisplayRiskLabel, isRMLikeRole, toINR } from '../../../utils/utilityFunctions';
import FundManagerDetails from './FundManagerDetails';
import { CompaniesTable } from '../../dashboard/table/CompaniesTable';
import { SectorsTable } from '../../dashboard/table/SectorTable';
import { useHistory } from "react-router";
import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { GetHistoricalNavResponseBody, GetIndividualFundDetailsResponseBody, HistoricalNavItem, MandateListItem, MandatesListResBody } from '../../../redux-store/types/investorProfile';
import { useParams } from 'react-router-dom';
import { getHistoricalNavDetails, getIndividualFundDetails, getMandatesList, individualOnbYrData, setAppliedFundsFilters, setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo, setSelectedSchemesObj } from '../../../redux-store/actions/investorProfile';
import BreadCrum from '../../../lib/BreadCrum';
import { RootStateType } from '../../../redux-store/reducers';
import { ErrorText } from '../../dashboard/chart/CustomeLineChart';
import { showError } from '../../../redux-store/actions/auth';
import { FUND_DETAILS_FREQUENCY, HELDAWAY_PORTFOLIO_STATUS, USER_ROLES } from '../../../utils/constant';
import { reportDownload } from '../../Reports/report-utils';
import { ChevronRight } from '@mui/icons-material';
import { Formik, FormikProps } from 'formik';
import { CustomeBlueDatePicker, CustomeNumberInput, PickUpInput } from '../transcation/FromInput';
import { LoadingButton } from '@mui/lab';
import * as yup from 'yup';
import OTPForm from '../../../lib/formik/OtpForm';
import { useRefDebounce } from '../../../utils/useDebounce';
import dayjs from 'dayjs';
import { handleDateValidation } from '../transcation/Sip';
import { addToCart, getCartItemsCount, setCartItemsCount } from '../../../redux-store/actions/cart';
import { AddToCartResponseBody, GetCartItemsCountResponseBody } from '../../../redux-store/types/cart';
import AddtoCardPopup from '../common/AddtoCardPopup';
import ValidateDialogBox from '../mutualFund/common/ValidateDialogBox';
import { getInvestmentUserDetails, getRiskProfileCheck, submitInvestmentDetails, submitRecomment } from '../../../redux-store/actions/funds';
import { GetInvestmentUserDetails } from '../../../redux-store/types/api-types';
import SuccessModal from '../common/SuccessModal';
import ConfirmRecomment from '../common/ConfirmRecomment';
import RiskProfilePopup from '../common/RiskProfilePopup';
import FiveSchemeErrorMessage from '../mutualFund/common/FiveSchemeErrorMessage';
import { useSnackbar } from 'notistack';
import { KeyValue } from '../../ApplicationDetails/personalDetails';


interface Companies {
    companyName: string;
    allocation: number;
}

interface Sectors {
    sectorName: string;
    allocation: number;
}

interface Holdings {
    categoryType: string;
    categoryPercentage: number;
    companies: Array<Companies>;
    sectors: Array<Sectors>;
}

interface OtherFundsManagedProps {
    name: string;
}
interface FundManagerProps {
    name: string;
    serviceStartPeriod: string | null;
    servicePeriod: string;
    education: string;
    experience: string;
    otherFundsManaged: Array<OtherFundsManagedProps>
}
interface FundDetails {
    name: string;
    fundCategory: string;
    riskType: string;
    minimumLumpsum: number;
    minSIP: number;
    AUM: number;
    expenseRatio: number;
    exitLoad: number;
    holdings: Array<Holdings>;
    fundManagers: Array<FundManagerProps>
}

interface Params {
    investorId: string;
    individualFundId: string
}

interface FormikValues {
    activeTab: string,
    mandate: any,
    lumpSum: {
        lumpSumAmount: string,
        minimumLumpsum: string | number
    },
    sip: {
        sipAmount: string,
        sipDate: any,
        minSip: string | number,
        validationDates: Array<any>
    },
    submitAction: string,
}

const initialValues = {
    activeTab: 'sip',
    mandate: {},
    lumpSum: {
        lumpSumAmount: '50000',
        minimumLumpsum: "",
    },
    sip: {
        sipAmount: '25000',
        sipDate: '',
        minSip: '',
        validationDates: []
    },
    submitAction: '',
}

const validationSchema = yup.object().shape({
    activeTab: yup.string().required('Active Tab is required'),
    lumpSum: yup.object()
        .when('activeTab', {
            is: (value: string) => `${value ?? ''}`.toLowerCase() === 'lumpsum',
            then: yup.object().shape({
                lumpSumAmount: yup
                    .string()
                    .nullable()
                    .required('Lumpsum Amount is required')
                    .test(
                        'min-lumpsum-msg',
                        function (value) {
                            const { minimumLumpsum } = this.parent;
                            if (!minimumLumpsum || !value) return true;
                            return Number(value) >= Number(minimumLumpsum)
                                ? true
                                : this.createError({
                                    message: `Minimum Lumpsum Amount is ${minimumLumpsum}`,
                                });
                        }
                    ),
            }),
            otherwise: yup.object().notRequired()
        }),
    sip: yup.object()
        .when('activeTab', {
            is: (value: string) => `${value ?? ''}`.toLowerCase() === 'sip',
            then: yup.object().shape({
                sipAmount: yup
                    .string()
                    .nullable()
                    .required('SIP Amount is required')
                    .test(
                        'min-sip',
                        function (value) {
                            const { minSip } = this.parent; // from Formik's sip object
                            if (!minSip || !value) return true;
                            return Number(value) >= Number(minSip)
                                ? true
                                : this.createError({
                                    message: `Minimum SIP Amount is ${minSip}`,
                                });
                        }
                    ),
                sipDate: yup.date()
                    .nullable()
                    .typeError('Invalid Date')
                    .required('SIP Date is Required')
                    .test('validations', '', function (value, context) {
                        const { parent, createError, path, options } = context;
                        const validationData = parent?.validationDates ?? [];
                        const mandateLength = options?.context?.mandate ? Object.keys(options?.context?.mandate ?? {}).length : 0;
                        const today = dayjs();
                        const sipDate = dayjs(value);

                        const nextValidDate = findNextValidDate(validationData, 'active', true, FUND_DETAILS_FREQUENCY);

                        // const dow = sipDate.day(); // 0=Sun,6=Sat
                        // if (dow === 0 || dow === 6) {
                        //     return createError({ path, message: 'Weekends (Sat/Sun) are not allowed' });
                        // }


                        if (mandateLength > 0) {
                            // if (!validationData?.length) {
                            //     return createError({ path, message: 'No valid SIP dates configured.' });
                            // }
                            if (today.add(2, 'days').isAfter(sipDate, 'day')) {
                                return createError({ path, message: 'Date should be T+2' });
                            }
                            if (sipDate.isBefore(nextValidDate, 'day')) {
                                return createError({ path, message: `Date should be ${nextValidDate?.format('DD/MM/YYYY')} and onwards` });
                            }
                            const invalid = handleDateValidation(validationData, sipDate, true, FUND_DETAILS_FREQUENCY);
                            if (invalid) {
                                return createError({
                                    path,
                                    message: `Only ${validationData.join(', ')} are allowed`,
                                });
                            }
                        }
                        else {
                            if (sipDate.isBefore(nextValidDate, 'day')) {
                                return createError({ path, message: `Date should be ${nextValidDate?.format('DD/MM/YYYY')} and onwards` });
                            }
                        }
                        if (today.isAfter(sipDate, 'day')) {
                            return createError({ path, message: 'Past date is not allowed' });
                        }

                        return true;
                    })
            }),
            otherwise: yup.object().notRequired()
        })
})

function SchemeDetails({
    loading,
    fundDetails,
    checkAmcId
}: {
    loading: boolean;
    fundDetails: GetIndividualFundDetailsResponseBody;
    checkAmcId?: string
}) {
    const theme = useTheme()

    return (
        <Box component={'div'} sx={{ display: 'flex', alignItems: { xs: "flex-start", sm: 'center' }, justifyContent: 'flex-start', columnGap: '15px', mb: { lg: '10px' } }}>
            {loading
                ? <Skeleton animation="wave" width={50} height={50} variant="rectangular" />
                :
                <Box
                    component="img"
                    alt={fundDetails?.name ?? ""}
                    src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                    sx={{ width: "40px", height: "40px", objectFit: "contain", alignSelf: 'flex-start' }}
                />
            }


            <Box component={'div'}>
                {loading ?
                    <Skeleton animation="wave" sx={{ width: { xs: '100%' } }} />
                    :
                    <Typography
                        variant='body_500'
                        sx={{ fontWeight: '600' }}
                    >
                        {fundDetails?.name ?? ""}
                    </Typography>}
                {loading ?
                    <Box>
                        <Skeleton animation="wave" width={'200px'} />
                    </Box>
                    :
                    <>
                        <Box component={'div'} sx={{ display: { xs: "flex", sm: 'inline-flex' }, alignItems: 'center', flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
                            {fundDetails?.fundCategory === "NULL" || fundDetails?.fundCategory === null ?
                                <></>
                                :
                                <Typography component={'span'} variant='body_400' sx={{ color: 'text.secondary', letterSpacing: '0.02px' }} >
                                    {`${fundDetails?.fundCategory ?? ""}`}
                                </Typography>
                            }
                            <Box component={'span'} sx={(theme: Theme) => (
                                {
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    mx: '6px',

                                    background: theme.palette.text.secondary,
                                }
                            )}></Box>
                            {fundDetails?.fundTypeCategory === "NULL" || fundDetails?.fundTypeCategory === null ?
                                <></>
                                :
                                <Typography component={'span'} variant='body_400' sx={{ color: 'text.secondary', letterSpacing: '0.02px' }} >{`${fundDetails?.fundTypeCategory ?? ""}`}
                                </Typography>
                            }
                            {fundDetails?.riskType === "NULL" || fundDetails?.riskType === null ? <></> : <>
                                <Box component={'span'} sx={(theme: Theme) => (
                                    {
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '5px',
                                        height: '5px',
                                        borderRadius: '50%',
                                        mx: '6px',
                                        background: theme.palette.text.secondary,
                                    }
                                )} />
                                <Typography component={'span'} variant='body_400' sx={(theme: Theme) => (
                                    { color: theme.palette.text.secondary, letterSpacing: '0.02px' }
                                )} >{getDisplayRiskLabel(fundDetails?.riskType ?? "")}</Typography>
                            </>}
                        </Box>
                        {/* Here */}
                        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mt: '5px' }}>
                            {fundDetails?.fundRating?.trim().toLowerCase() === 'not rated'
                                ?
                                <Typography
                                    variant='body_500'
                                >
                                    Not Rated
                                </Typography>
                                : !Number(fundDetails?.fundRating) ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '5px', border: `1px solid ${theme.palette.customColors.pastelGrey}`, padding: '5px 10px', borderRadius: '10px' }}>
                                        {/* <BorderStarFilled /> */}
                                        <Typography
                                            variant="body_500"
                                            sx={(theme) => ({
                                                color: theme.palette.text.primary,
                                            })}
                                        >
                                            Not Rated
                                        </Typography>
                                    </Box>
                                ) :
                                    ([...Array(Math.max(0, Math.floor(Number(fundDetails?.fundRating ?? 0))))].map((_, idx) => (
                                        <Box key={idx}>
                                            <GoldenStarFilled width={{ xs: '12', sm: '16' }} height={{ xs: '12', sm: '16' }} />
                                        </Box>
                                    )))
                            }
                        </Box>
                    </>
                }
            </Box>
        </Box>
    )
}

export default function IndividualFundDetails(): JSX.Element {
    const history = useHistory()
    const { pathname: pathName, state } = history.location;
    const dispatch = useDispatch();
    const theme = useTheme();

    const { individualFundId: schemeId } = useParams<Params>();
    const { selectedSchemes, clientCode, selectedCategory = "" } = (state as { selectedSchemes?: Array<{ [key: string]: any }>, clientCode?: string, selectedCategory?: string }) ?? []
    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const { isPortfolioHeldaway, selectedPortfolio, selectedPortfolioObj } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const { investorClientId = "", clientInterfaceCode = "", iwappRmId = "", familyMemberId = "" } = useSelector((store: RootStateType) => store.id);
    const [activeMandList, setActiveMandList] = useState<Array<MandateListItem>>([]);
    const [isMandateLoading, setMandateLoading] = useState<boolean>(false);
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const [fundDetails, setFundDetails] = useState<GetIndividualFundDetailsResponseBody>({} as GetIndividualFundDetailsResponseBody);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(0);
    const [selectedTab, setSelectedTab] = useState('companies');
    const [navRes, setNavRes] = useState<GetHistoricalNavResponseBody>({
        message: '',
        isSuccess: false,
        result: [],
    });
    const [allFundData, setAllFundData] = useState<Array<HistoricalNavItem>>([]);

    const [currentFundData, setCurrentFundData] = useState<Array<HistoricalNavItem>>([]);

    const [showAllCompanies, setShowAllCompanies] = useState(false);
    const [navChartBtn, setNavChartBtn] = useState('Inception');
    const [vrLoading, setVrLoading] = useState({
        sid: false,
        kim: false,
        fs: false,
        sai: false
    })
    const [moreFundInfo, setMoreFundInfo] = useState<boolean>(false);
    const [isOtpDialogOpen, setOtpDialogOpen] = useState<boolean>(false);
    const [otpDialogData, setOtpDialogData] = useState<any>({});
    const [isConfirmationDialogVisible, setConfirmationDialogVisible] = useState<boolean>(false)
    const [cartPopup, setCartPopup] = useState<boolean>(false);
    const [validationErrorsArray, setValidationErrorsArray] = useState<{ schemeName: string; errorMessage: string }[]>([])
    const [isValidationDialogVisible, setValidationDialogVisible] = useState<boolean>(false)
    const [userDetails, setUserDetails] = useState<GetInvestmentUserDetails>({} as GetInvestmentUserDetails);
    const [recommendPlaceOrderResponse, setRecommendPlaceOrderResponse] = useState<any>({})
    const [confirmRecomment, setConfirmRecomment] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [riskPflChkLoading, setRiskPflChkLoading] = useState<boolean>(false);
    const [riskProfilePopup, setRiskProfilePopup] = useState<boolean>(false);
    const [riskPopupText, setRiskPopupText] = useState<string>('');
    const [apiLoading, setApiLoading] = useState(false);
    const [isFiveSchemesDialogVisible, setFiveSchemesDialogVisible] = useState<boolean>(false)
    const { enqueueSnackbar } = useSnackbar();



    const [values, setInitialValues] = useState<FormikValues>(initialValues);
    const debounce = useRefDebounce(500);

    let successMessage = ""
    const fetchSuccessMsg = () => {
        if (formikRef?.current?.values?.submitAction === 'cart' && isRMLikeRole(role)) {
            successMessage = "Your Recommendation is sent successfully to the Investor."
        }
        else if (formikRef?.current?.values?.submitAction === 'order' && isRMLikeRole(role)) {
            successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} successfully sent to the investor for approval. Once authorized and approved the order will be placed.`
        }

        return successMessage;
    }



    const handleShowAllCompaniesToggle = () => {
        setShowAllCompanies(!showAllCompanies);
    };

    const navChartButtons = [
    //     {
    //     type: 'month',
    //     count: 1,
    //     text: '1M'
    // }, {
    //     type: 'month',
    //     count: 6,
    //     text: '6M'
    // }, 
    {
        type: 'year',
        count: 1,
        text: '1Y'
    }, {
        type: 'year',
        count: 3,
        text: '3Y'
    }, {
        type: 'year',
        count: 5,
        text: '5Y'
    },
    {
        type: 'all',
        text: 'Inception'
    }]

    const tabList = [
        {
            key: 'sip',
            label: 'Monthly SIP'
        },
        {
            key: 'lumpsum',
            label: "Lumpsum"
        }
    ]

    interface IndNavBtnProps {
        type: string,
        count?: number,
        text: string
    }



    const sortHoldingsByAllocation = (fundData: GetIndividualFundDetailsResponseBody) => {
        fundData?.holdings?.forEach(holding => {
            holding.companies.sort((a, b) => b.allocation - a.allocation);
            holding.sectors.sort((a, b) => b.allocation - a.allocation);
        });
        return fundData;
    };

    const fetchIndividualFundData = async () => {

        try {
            setLoading(true);
            const individualFundPayload = {
                schemeId: schemeId,
            }

            const historicalPayload = {
                schemeId: selectedSchemes?.[0]?.mPowerScheme ?? ''
            }

            const [individualFundRes, historicalNavRes] = await Promise.allSettled([
                (dispatch(getIndividualFundDetails(individualFundPayload)) as unknown as Promise<GetIndividualFundDetailsResponseBody>),
                (dispatch(getHistoricalNavDetails(historicalPayload)) as unknown as Promise<GetHistoricalNavResponseBody>)
            ]);

            setFundDetails(sortHoldingsByAllocation(individualFundRes?.status === 'fulfilled' ? individualFundRes?.value : fundDetails));

            if (individualFundRes?.status === 'fulfilled') {
                const fulfilledResult = individualFundRes as PromiseFulfilledResult<GetIndividualFundDetailsResponseBody>;
                formikRef?.current?.setFieldValue('sip.minSip', fulfilledResult?.value?.minSip ?? 0);
                formikRef?.current?.setFieldValue('sip.validationDates', fulfilledResult?.value?.sipInvDates ?? []);
                formikRef?.current?.setFieldValue('lumpSum.minimumLumpsum', fulfilledResult?.value?.minimumLumpsum ?? 0);
                // setInitialValues({
                //     ...values,
                //     sip: {
                //         ...values.sip,
                //         minSip: fulfilledResult?.value?.minSip ?? 0,
                //         validationDates: fulfilledResult?.value?.sipInvDates ?? []
                //     },
                //     lumpSum: {
                //         ...values.lumpSum,
                //         minimumLumpsum: fulfilledResult?.value?.minimumLumpsum ?? 0
                //     },
                // });
            }

            setNavRes(historicalNavRes?.status === 'fulfilled' ? historicalNavRes?.value : navRes);
            setAllFundData(historicalNavRes?.status === 'fulfilled' ? historicalNavRes?.value?.result : []);
            setCurrentFundData(historicalNavRes?.status === 'fulfilled' ? (historicalNavRes?.value?.result?.length > 0 ? [...historicalNavRes?.value?.result] : []) : [])
        } catch (e) {
            console.log("ERROR", e);
        } finally {
            setLoading(false);
        }
    }

    const fetchUserDetails = async () => {
        if (role === USER_ROLES.INVESTOR && investorClientId) {
            const userDetailsResponse = await (dispatch(getInvestmentUserDetails(
                { clientCode: investorClientId, portfolioId: selectedPortfolio?.value }
            )) as unknown as Promise<GetInvestmentUserDetails>)

            if (Object.keys(userDetailsResponse).length) {
                setUserDetails({
                    name: userDetailsResponse?.name ?? "",
                    status: userDetailsResponse?.status ?? "",
                    mobile: userDetailsResponse?.mobile ?? "",
                    email: userDetailsResponse?.email ?? "",
                    accountType: userDetailsResponse?.accountType ?? "",
                })
            }
        }
    }

    // const fetchMandateList = async () => {
    //     try {
    //         const list = await (dispatch(getMandatesList({ clientCode: clientCode || investorClientId, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<MandatesListResBody>);
    //         setActiveMandList(list?.mandates || []);
    //     } catch (e) {
    //         console.log('e', e)
    //     }
    // }

    useEffect(() => {
        fetchIndividualFundData();
        fetchUserDetails();
        findMandateByAmount(Number(formikRef?.current?.values?.sip?.sipAmount));
        // fetchMandateList();
    }, [])

    const handleChange = (newValue: number) => {
        setValue(newValue);
    };


    const handleNavChartBtn = (btn: string) => {
        setNavChartBtn(btn);
        const temp_filteredData = filterDataPointsForNav(allFundData, btn);
        setCurrentFundData(temp_filteredData?.length > 0 ? [...temp_filteredData] : []);

    }

    const handleProceedButton = () => {
        if (isPortfolioHeldaway) {
            dispatch(showError(HELDAWAY_PORTFOLIO_STATUS))
            return
        }

        history.push(`${pathName}/investment-details`, { selectedSchemes, clientCode, comingFrom: "individualFund", sipAmount: formikRef?.current?.values?.sip?.sipAmount });
    }

    const initialRouter = pathName.split('/').filter((item) => item !== '')

    const rmRouterPath = [
        {
            name: 'Dashboard',
            path: '/dashboard',
        },
        ...(!initialRouter.includes('product') ? [{
            name: initialRouter[1] + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            }
        }] : []),
        {
            name: initialRouter.includes('product') ? "Mutual Funds" : 'Detailed Portfolio Holdings',
            path: initialRouter.includes('product')
                ? `/${initialRouter[0]}/${initialRouter[1]}`
                : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode
            },
            ...(initialRouter.includes('product') ? {
                search: `tab=Overview&portfolio=${selectedPortfolio?.value ?? ""}`
            } : {})
        },
        {
            name: 'Explore Mutual Funds',
            path: initialRouter.includes('product')
                ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`
                : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode
            }
        },
        ...(initialRouter.includes('selected-category-funds') ? [{
            name: 'Selected Category Funds',
            path: initialRouter.includes('product')
                ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`
                : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`,
            state: {
                clientCode,
                selectedCategory
            }
        }] : []),
        {
            name: fundDetails?.name || 'Loading...',
            path: initialRouter.includes('product')
                ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`
                : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}/${initialRouter[5]}`,
            state: {
                clientCode
            }
        }

    ]

    const investorRouterPath = [
        ...(familyMemberId
            ?
            [{
                name: 'View Family',
                path: `/investor-family/family-profile/${familyMemberId}`,
            },
            {
                name: `${initialRouter[1]}`,
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            }]
            :
            [{
                name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
                path: '/investor-dashboard',
            }]
        ),
        {
            name: 'Detailed Portfolio Holdings',
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}` : `/${initialRouter[0]}/${initialRouter[1]}`),
            state: {
                clientCode
            },
            search: `tab=Overview&portfolio=${selectedPortfolio?.value ?? ""}`
        },
        {
            name: 'Explore Mutual Funds',
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}` : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`),
            state: {
                clientCode
            }
        },
        ...(initialRouter.includes('selected-category-funds') ? [{
            name: 'Selected Category Funds',
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}` : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`),
            state: {
                clientCode,
                selectedCategory
            }
        }] : []),
        {
            name: fundDetails?.name || 'Loading...',
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}/${initialRouter[5]}` : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`),
            state: {
                clientCode
            }
        }
    ]

    const amcIds = ['BDOTR', 'BPIAMC']
    const checkAmcId = amcIds.includes(fundDetails?.amcId ?? '') ? fundDetails?.amcId?.toLowerCase() : fundDetails?.amcId;

    const downloadSIDDoc = async (id: string | number) => {
        try {
            setVrLoading({
                ...vrLoading,
                sid: true
            })
            if (id === "") {
                dispatch(showError("ID not found"));
                return;
            }
            const res = (await dispatch(individualOnbYrData(id, "sid"))) as unknown as any;
            reportDownload(res as unknown as Blob, `SID_${id}.pdf`);
            // enqueueSnackbar('Downloaded successfully', {
            //     variant: 'success',
            //     autoHideDuration: 3000,
            // });
            return;
        } catch (e) {
            console.log('error', e);
        } finally {
            setVrLoading({
                ...vrLoading,
                sid: false
            })
        }
    }

    const downloadKimDoc = async (id: string | number) => {
        try {
            setVrLoading({
                ...vrLoading,
                kim: true
            })
            if (!id) {
                dispatch(showError("ID not found"));
                return;
            }
            const res = (await dispatch(individualOnbYrData(id, "kim"))) as unknown as any;
            reportDownload(res as unknown as Blob, `KIM_${id}.pdf`);
            enqueueSnackbar('Downloaded successfully', {
                variant: 'success',
                autoHideDuration: 3000,
            });
            return;
        } catch (e) {
            console.log('error', e);
        } finally {
            setVrLoading({
                ...vrLoading,
                kim: false
            })
        }
    }

    const downloadFsDoc = async (id: string | number) => {
        try {
            setVrLoading({
                ...vrLoading,
                fs: true
            })
            if (!id) {
                dispatch(showError("ID not found"));
                return;
            }
            const res = (await dispatch(individualOnbYrData(id, "factsheet"))) as unknown as any;
            reportDownload(res as unknown as Blob, `FS${id}.pdf`);
            enqueueSnackbar('Downloaded successfully', {
                variant: 'success',
                autoHideDuration: 3000,
            });
            return;
        } catch (e) {
            console.log('error', e);
        } finally {
            setVrLoading({
                ...vrLoading,
                fs: false
            })
        }
    }

    const downloadSAIDoc = async (id: string | number) => {
        try {
            setVrLoading({
                ...vrLoading,
                sai: true
            })
            if (!id) {
                dispatch(showError("ID not found"));
                return;
            }
            const res = (await dispatch(individualOnbYrData(id, "sai"))) as unknown as any;
            reportDownload(res as unknown as Blob, `SAI${id}.pdf`);
            enqueueSnackbar('Downloaded successfully', {
                variant: 'success',
                autoHideDuration: 3000,
            });
            return;
        } catch (e) {
            console.log('error', e);
        } finally {
            setVrLoading({
                ...vrLoading,
                sai: false
            })
        }
    }

    const displayExitLoad =
        fundDetails?.exitLoad === 0 || fundDetails?.exitLoad == null || fundDetails?.exitLoad === undefined
            ? fundDetails?.exitLoadNote
            : `${fundDetails?.exitLoad}%`;

    const displayExpenseRatio =
        fundDetails?.expenseRatio == null
            ? "Please refer to factsheet"
            : `${fundDetails?.expenseRatio}%`;


    const DETAIL_ROWS = [
        {
            key: 'expenseRatio',
            label: 'Expense Ratio',
            icon: <MutualFundsActiveIcon />,
            value: fundDetails?.expenseRatio,
            displayValue: displayExpenseRatio,
            tooltip: 'Expense ratio is the fees charged by mutual fund companies to manage the mutual fund.',
            getVariant: (val: any) => (val ? 'body_600' : 'overline_400')
        },
        {
            key: 'exitLoad',
            label: 'Exit Load',
            icon: <ExitLoadIcon />,
            value: fundDetails?.exitLoad,
            displayValue: displayExitLoad,
            tooltip: "Exit load is the fees charged by AMC's for premature redemption of mutual fund units.",
            getVariant: (val: any) => (val === 0 || val == null ? 'overline_400' : 'body_600')
        }
    ];

    const DOC_ROWS = [
        {
            key: 'sid',
            label: "Scheme Information Document(SID)",
            onClick: () => downloadSIDDoc(fundDetails?.fundId ?? ''),
            check: !!fundDetails?.fundId
        },
        {
            key: 'kim',
            label: "Key Information Memorandum(KIM)",
            onClick: () => downloadKimDoc(fundDetails?.fundId ?? ''),
            check: !!fundDetails?.fundId
        },
        {
            key: 'sai',
            label: "Statement of Additional Information (SAI)",
            onClick: () => downloadSAIDoc(fundDetails?.amcId ?? ''),
            check: !!fundDetails?.amcId
        },
        {
            key: 'fs',
            label: "FactSheet(FS)",
            onClick: () => downloadFsDoc(fundDetails?.amcId ?? ''),
            check: true
        },
    ];

    const findMandateByAmount = async (amount: number) => {
        try {
            setMandateLoading(true);
            const mandatesListRes = await (dispatch(getMandatesList({ amount: amount, clientCode: clientCode || investorClientId, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<MandatesListResBody>);
            setActiveMandList(mandatesListRes?.mandates || []);
            setMandateLoading(false);
            if (mandatesListRes?.mandates?.length && formikRef?.current) {
                formikRef.current.setFieldValue('mandate', mandatesListRes?.mandates?.[0]);
                const nextValidDate = findNextValidDate(fundDetails?.sipInvDates ?? [], 'active', true, FUND_DETAILS_FREQUENCY);
                formikRef.current.setFieldValue('sip.sipDate', nextValidDate);
            }
            else {
                const nextValidDate = findNextValidDate(fundDetails?.sipInvDates ?? [], 'pending', true, FUND_DETAILS_FREQUENCY)
                formikRef?.current?.setFieldValue('sip.sipDate', nextValidDate);
            }
        } catch (e) {
            console.error('Error in fetching data');
        }
    }

    const handleOnChange = (value: string | number) => {
        formikRef.current?.setFieldValue('mandate', {});
        debounce(() => {
            if (Number(value) >= Number(formikRef?.current?.values?.sip?.minSip ?? 0)) {
                findMandateByAmount(Number(value));
            }
        })
    }

    const handleSuccessPopup = () => {
        dispatch(setAppliedFundsFilters([]));
        dispatch(setSelectedSchemesObj({}));

        if (role === USER_ROLES.INVESTOR) {
            history.push('/investor-dashboard')
        } else {
            history.push('/dashboard')
        }
    }

    const handleConfirmRecommend = async (values: FormikValues) => {
        setApiLoading(true);
        const payload =
            [{
                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                amcId: fundDetails?.amcId,
                schemeId: fundDetails?.schemeId,
                schemeName: fundDetails?.name,
                categoryName: fundDetails?.fundCategory ?? '',
                subCategoryName: fundDetails?.fundTypeCategory ?? '',
                riskType: fundDetails?.riskType ?? "",
                aumAmount: fundDetails?.AUM ?? 0,
                navValue: fundDetails?.currentNav ?? 0,
                y3Returns: fundDetails?.year3Return ?? 0,
                exitLoad: fundDetails?.exitLoadNote ?? "",
                investedValue: 0,
                marketValue: 0,
                recommendedDate: dayjs().format("DD/MM/YYYY"),
                imgUrl: "",
                folioNo: "New folio",
                ...(values?.activeTab?.toLowerCase() === 'lumpsum' ? {
                    buySellType: "LUMPSUM",
                    recommendedAmount: `${values?.lumpSum?.lumpSumAmount}`,
                } : {
                    buySellType: "XSIP",
                    mandateId: values?.mandate?.mandateId ?? "",
                    noOfInstallments: "9999",
                    systematicDate: dayjs(values?.sip?.sipDate).format("DD/MM/YYYY"),
                    frequency: "MONTHLY",
                    recommendedAmount: `${values?.sip?.sipAmount}`,
                    firstOrderFlag: "Y",
                }),
                portfolioId: selectedPortfolio?.value,
                rmId: `${iwappRmId}`
            }]
        try {
            const res = (await dispatch(submitRecomment(payload))) as unknown as {
                isSuccess: boolean,
                message: string,
                response: Array<any>
            };

            if (res?.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res?.response.length > 0) {
                    setValidationErrorsArray(
                        res.response
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data.schemeName,
                                errorMessage: data.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (e) {
            console.error('Error', e);
        } finally {
            setApiLoading(false);
            setConfirmRecomment(false);
        }
    }

    const handleConfirmOrder = async (values: FormikValues) => {
        setApiLoading(true);
        const payload = [{
            clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
            fromScheme: fundDetails?.schemeId,
            schemeName: fundDetails?.name,
            mobile: userDetails?.mobile,
            email: userDetails?.email,
            amcId: fundDetails?.amcId,
            folio: "New folio",
            ...((values?.activeTab?.toLowerCase() === 'lumpsum') ? {
                amount: values?.lumpSum?.lumpSumAmount,
                trType: "FRESH",
                // trType: "LUMPSUM",
                // ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                //     folio: item?.folio?.folioId,
                //     trType: "ADDITIONAL",
                //     investedValue: folio?.[i].investedValue,
                //     marketValue: folio?.[i].marketValue,
                // }),
                // ...((
                //     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                //     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                // ) ? {
                //     bankName: selectedBankDetailsObj?.bankname ?? "",
                //     bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                //     bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                // } : {})
            } : {
                trType: "XSIP",
                transactionStartDate: dayjs(values?.sip?.sipDate).format("DD/MM/YYYY"),
                mandateId: values?.mandate?.mandateId ?? "",
                // mandateId: item?.sip?.curMandateStatus === 'active' ? item?.sip?.active?.mandateId : null,
                noOfInstallments: '9999',
                frequency: 'MONTHLY',
                amount: values?.sip?.sipAmount,
                // mandate_payload: item?.sip?.curMandateStatus === 'active' ? null : item?.sip?.freshMandatePayload ?? "",
                // isFirstorderToday: "Y",
                firstOrderFlag: "Y",
                // ...(pathname?.split('/')[pathname?.split('/')?.length - 1] !== 'invest-more' ? {} : {
                //     folio: item?.folio?.folioId,
                //     investedValue: folio?.[i].investedValue,
                //     marketValue: folio?.[i].marketValue,
                // }),
                // ...((
                //     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                //     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                // ) ? {
                //     bankName: selectedBankDetailsObj?.bankname ?? "",
                //     bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                //     bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                // } : {})
            }),
            portfolioId: selectedPortfolio?.value,
            portfolioName: selectedPortfolio?.label,
            rmId: `${iwappRmId}`,
            cartId: null,
            isRecommended: isRMLikeRole(role) ? true : false,
            isDiy: role === USER_ROLES.INVESTOR ? true : false,

        }]

        try {
            const res = await dispatch(submitInvestmentDetails({
                // ...(ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD ? {
                accountType: selectedPortfolioObj?.portfolioAccountType,
                // } : {}),
                orderDetails: payload,
                // ...((
                //     ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                //     isRMLikeRole(role) &&
                //     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                //     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                // ) ? {
                //     documents: formRef?.current?.values?.documents?.filter((obj: {
                //         documentId: string;
                //         documentType: string;
                //     }) => obj.documentId !== "" && obj.documentType !== "")
                // } : {})
            })) as unknown as {
                isSuccess: boolean,
                message: string,
                ordersValidation: Array<any>
                isPaymentFlow?: boolean
                token?: string
                cartId?: string
                otp_response?: any
            };
            if (res?.isSuccess) {
                if (role === USER_ROLES.INVESTOR && res?.isPaymentFlow) {
                    history.push('/cart/verify-otp', {
                        token: res?.token ?? "",
                        cartId: res?.cartId ?? "",
                        id: res?.otp_response?.id ?? "",
                        otpMessage: res?.otp_response?.message ?? "",
                    })
                }
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                if (res?.ordersValidation.length > 0) {
                    setValidationErrorsArray(
                        res?.ordersValidation
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data?.schemeName,
                                errorMessage: data?.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (e) {
            console.error('Error', e);
        } finally {
            setApiLoading(false);
            setConfirmRecomment(false);
        }
    }

    const handleRiskProfilePopup = (btnText: string) => {
        if (btnText === 'cancel') {
            if (isRMLikeRole(role)) {
                history.push(`/investor-profile/${selectedPortfolio?.label}/mutual-fund/explore`, state);
            }
            else {
                history.goBack();
            }
        }
        else if (btnText === 'continue') {
            // setConfirmRecomment(true);
            handleConfirmOrder(formikRef?.current?.values ?? {} as FormikValues)
        }
        setRiskProfilePopup(false);
    }


    const handleSubmit = async (values: FormikValues) => {
        if (values.submitAction === 'proceed') {
            handleProceedButton();
        }
        if (values.submitAction === 'cart' && isRMLikeRole(role)) {
            try {
                setRiskPflChkLoading(true);
                const riskProfileCheckRes = await dispatch(getRiskProfileCheck({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                    schemeCode: [fundDetails?.schemeId ?? '']
                })) as unknown as {
                    isSuccess: boolean,
                    displayText: string
                }
                if (!riskProfileCheckRes?.isSuccess) {
                    setRiskProfilePopup(true)
                    setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                } else {
                    setConfirmRecomment(true)
                }
            } catch (e) {
                console.log('error', e)
            } finally {
                setRiskPflChkLoading(false);
            }
        }
        else if (values.submitAction === 'cart' && role === USER_ROLES.INVESTOR) {
            setApiLoading(true);
            const payload = [{
                categoryName: fundDetails?.fundCategory ?? "",
                isDividendReinvestment: fundDetails?.divReinvestAllowed ?? "",
                mPowerScheme: fundDetails?.schemeId ?? "",
                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                navValue: `${fundDetails?.currentNav ?? ""}`,
                y3Returns: fundDetails?.year3Return ?? 0,
                exitLoad: fundDetails?.exitLoadNote ?? "",
                aumAmount: fundDetails?.AUM ?? 0,
                riskType: fundDetails?.riskType ?? "",
                schemeId: fundDetails?.schemeId ?? '',
                schemeName: fundDetails?.name ?? '',
                subCategoryName: fundDetails?.fundTypeCategory ?? '',
                isRecommended: false,
                navDate: fundDetails?.navDate ?? '',
                folioNo: "New folio",
                trType: values?.activeTab?.toLowerCase() === "lumpsum" ? 'FRESH' : 'SIP',
                investedValue: "0",
                marketValue: "0",
                amcId: fundDetails?.amcId ?? "",
                ...((values?.activeTab?.toLowerCase() === "lumpsum") ? {
                    amount: values?.lumpSum?.lumpSumAmount,
                } : {
                    amount: values?.sip?.sipAmount,
                    mandateId: values?.mandate?.mandateId ?? "",
                    frequency: "MONTHLY",
                    noOfInstallment: '9999',
                    sipDate: dayjs(values?.sip?.sipDate).format("DD/MM/YYYY"),
                    firstOrderFlag: 'Y',
                }),
                portfolioId: selectedPortfolio?.value,
                rmId: `${iwappRmId}`,
                transMode: 'A',
            }]
            try {
                const res = await dispatch(addToCart(payload as any) as unknown) as AddToCartResponseBody;
                if (res?.isSuccess) {
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : (clientCode ?? ""),
                        portfolioId: selectedPortfolio?.value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)
                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                        dispatch(setSelectedHoldingsInfo([]))
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }

                    setCartPopup(true)

                } else if (!res?.isSuccess) {
                    if (res?.message) {
                        setFiveSchemesDialogVisible(true)
                    }
                    else if (!res?.message) {
                        setValidationErrorsArray(
                            res?.response
                                .filter(data => !data.isSuccess)
                                .map(data => ({
                                    schemeName: data.schemeName,
                                    errorMessage: data.message
                                }))
                        )
                        setValidationDialogVisible(true)
                    }
                }
            } catch (e) {
                console.error('error', e);
            } finally {
                setApiLoading(false);
            }
        }
        else if (values.submitAction === 'order' && isRMLikeRole(role)) {
            try {
                setRiskPflChkLoading(true);
                const riskProfileCheckRes = await dispatch(getRiskProfileCheck({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                    schemeCode: [fundDetails?.schemeId ?? ""]
                })) as unknown as {
                    isSuccess: boolean,
                    displayText: string
                }
                if (!riskProfileCheckRes?.isSuccess) {
                    setRiskProfilePopup(true)
                    setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                } else {
                    // setConfirmRecomment(true)
                    handleConfirmOrder(values)
                }
            } catch (e) {
                console.log('error', e)
            } finally {
                setRiskPflChkLoading(false);
            }
        }
        else if (values.submitAction === 'order' && role === USER_ROLES.INVESTOR) {
            try {
                setRiskPflChkLoading(true);
                const riskProfileCheckRes = await dispatch(getRiskProfileCheck({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                    schemeCode: [fundDetails?.schemeId ?? ""]
                })) as unknown as {
                    isSuccess: boolean,
                    displayText: string
                }
                if (!riskProfileCheckRes?.isSuccess) {
                    setRiskProfilePopup(true)
                    setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                } else {
                    // setConfirmRecomment(true)
                    handleConfirmOrder(values)
                }
            } catch (e) {
                console.log('error', e)
            } finally {
                setRiskPflChkLoading(false);
            }
        }
    }

    const handleAddToCart = () => {
        history.push('/cart', { clientCode })
    }

    const isNFOSelected = selectedCategory === "NFO";
    const isLessThanLgScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const findReturns = (btn: string) => {
        switch (btn) {
            case '1Y':
                return {
                    percentage: Number(fundDetails?.year1Return ?? 0).toFixed(2),
                    iconSign: (fundDetails?.year1Return ?? 0) < 0 ? <DownwardNegativeIcon /> : <UpWardPositiveIcon />,
                    color: (fundDetails?.year1Return ?? 0) < 0 ? theme.palette.error[500] : theme.palette.success[500]
                }

            case '3Y':
                return {
                    percentage: Number(fundDetails?.year3Return ?? 0).toFixed(2),
                    iconSign: (fundDetails?.year3Return ?? 0) < 0 ? <DownwardNegativeIcon /> : <UpWardPositiveIcon />,
                    color: (fundDetails?.year3Return ?? 0) < 0 ? theme.palette.error[500] : theme.palette.success[500]
                }

            case '5Y':
                return {
                    percentage: Number(fundDetails?.year5Return ?? 0).toFixed(2),
                    iconSign: (fundDetails?.year5Return ?? 0) < 0 ? <DownwardNegativeIcon /> : <UpWardPositiveIcon />,
                    color: (fundDetails?.year5Return ?? 0) < 0 ? theme.palette.error[500] : theme.palette.success[500]
                }

            case 'Inception':
                return {
                    percentage: Number(fundDetails?.sinceInception ?? 0).toFixed(2),
                    iconSign: (fundDetails?.sinceInception ?? 0) < 0 ? <DownwardNegativeIcon /> : <UpWardPositiveIcon />,
                    color: (fundDetails?.sinceInception ?? 0) < 0 ? theme.palette.error[500] : theme.palette.success[500]
                }

            default:
                return {
                    percentage: '',
                    iconSign: '',
                    color: theme.palette.common.white
                }
        }
    }

    return (
        <>
            <BreadCrum array={isRMLikeRole(role) ? rmRouterPath : investorRouterPath} />

            <Grid container columnSpacing={2} mt={'15px'}>

                <Hidden lgUp>
                    <Grid item xs={12} lg={pathName.includes('product') ? 12 : 8}>
                        <Box component={'section'} sx={(theme: Theme) => (
                            { padding: '25px 25px 23px 25px', borderRadius: '20px', background: theme.palette.common.white, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)', mb: "25px", width: '100%' }
                        )}>
                            <SchemeDetails
                                loading={loading}
                                fundDetails={fundDetails}
                                checkAmcId={checkAmcId}
                            />
                        </Box>
                    </Grid>
                </Hidden>

                {/* Main Grid */}
                <Grid item
                    xs={12}
                    lg={pathName.includes('product') ? 12 : 8}
                    sx={{
                        order: { xs: 2, lg: 0 },
                        height: { xs: "auto", sm: `calc(100vh - 180px)` }, overflow: 'auto',
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        }
                    }}>

                    {/* Fund Details and NAV chart */}
                    <Box component={'section'} sx={(theme: Theme) => (
                        { padding: '25px', borderRadius: '20px', background: theme.palette.common.white, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)', mb: "25px", display: (isLessThanLgScreen && isNFOSelected) ? 'none' : 'inherit' }
                    )}>
                        <Hidden lgDown>
                            <SchemeDetails
                                loading={loading}
                                fundDetails={fundDetails}
                                checkAmcId={checkAmcId}
                            />
                        </Hidden>

                        {!isNFOSelected && (
                            <>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        justifyContent: "center"
                                    }}
                                >
                                    {loading && (
                                        <>
                                            <Skeleton animation="wave" width="30%" />
                                            <Skeleton animation="wave" width="30%" sx={{ mb: '45px' }} />
                                        </>
                                    )}
                                    {!loading && (
                                        <>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Box
                                                    sx={(theme: Theme) => ({
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: '11px',
                                                        height: '11px',
                                                        borderRadius: '50%',
                                                        mx: '4px',
                                                        background: theme.palette.primary[500],
                                                    })}
                                                />
                                                <Typography
                                                    variant='body_400'
                                                    sx={{ color: 'text.secondary' }}
                                                >
                                                    {`NAV: ${fundDetails?.navDate ?? ""}`}
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    mb: { xs: 1, sm: 0 }
                                                }}
                                            >
                                                <Typography
                                                    component={'span'}
                                                    variant='body_400'
                                                    sx={{
                                                        fontWeight: '600',
                                                        color: 'text.primary',
                                                        mr: '4px'
                                                    }}
                                                >
                                                    {toINR({ value: fundDetails?.currentNav ?? 0, locale, currencyCode })}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                {/* {findReturns(navChartBtn).iconSign} */}
                                                <Typography
                                                    variant='body_500'
                                                    sx={(theme: Theme) => ({
                                                        color: findReturns(navChartBtn).color,
                                                    })}
                                                    component={'span'}
                                                >
                                                    {`${findReturns(navChartBtn).percentage}%`}
                                                </Typography>
                                            </Box>
                                        </>
                                    )}
                                </Box>
                                <Box>
                                    {loading ? <Box>

                                        {/* Y-axis skeleton */}
                                        <Box
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',

                                            }}
                                        >
                                            <Skeleton variant="rectangular" width={10} height={100} />
                                            <Skeleton variant="rectangular" width={10} height={100} />
                                            <Skeleton variant="rectangular" width={10} height={100} />
                                        </Box>

                                        {/* X-axis skeleton */}
                                        <Box
                                            style={{
                                                display: 'flex',
                                            }}
                                        >
                                            <Skeleton variant="rectangular" width={'100%'} height={10} />
                                            <Skeleton variant="rectangular" width={'100%'} height={10} />
                                            <Skeleton variant="rectangular" width={'100%'} height={10} />
                                        </Box>
                                    </Box>
                                        :
                                        <>
                                            <Box>
                                                {(!navRes?.isSuccess || !currentFundData?.length) ? <ErrorText /> :
                                                    <CustomNavChart
                                                        data={
                                                            currentFundData?.length ? currentFundData : []
                                                        }
                                                        height={300}
                                                    />}
                                            </Box>
                                            <Box
                                                sx={{
                                                    mt: '5px',
                                                    display: 'flex',
                                                    justifyContent: { xs: 'flex-start', md: 'center' },
                                                    alignItems: 'center',
                                                    columnGap: '15px',
                                                    overflowX: 'auto',
                                                    width: '100%',
                                                    // pb: 1,

                                                }}
                                            >
                                                {navChartButtons?.map((individualBtn: IndNavBtnProps, index: number) => (
                                                    <Button
                                                        key={index}
                                                        sx={(theme: Theme) => ({
                                                            ...theme.typography.body_400,
                                                            letterSpacing: '0.02px',
                                                            borderRadius: '7px',
                                                            padding: '5px 10px',
                                                            mb: 1,
                                                            minWidth: '80px',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            color: navChartBtn === individualBtn?.text
                                                                ? theme.palette.common.white
                                                                : theme.palette.text.secondary,
                                                            '&:hover': {
                                                                border: 'none',
                                                            },
                                                            flexShrink: 0,
                                                        })}
                                                        variant={navChartBtn === individualBtn?.text ? 'contained' : 'outlined'}
                                                        onClick={() => handleNavChartBtn(individualBtn?.text)}
                                                    >
                                                        {individualBtn?.text}
                                                    </Button>
                                                ))}
                                            </Box>


                                        </>
                                    }
                                </Box>
                            </>
                        )}
                    </Box>

                    {!isNFOSelected && (
                        <>
                            <Box component={'section'} sx={(theme: Theme) => (
                                { padding: '35px 30px', borderRadius: '20px', background: theme.palette.common.white, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)', mb: '25px' }
                            )}>
                                {loading ?
                                    <Skeleton animation="wave" width={'30%'} sx={{ mb: '35px' }} />
                                    :
                                    <Typography variant='h2' sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        mb: '35px'
                                    })}>
                                        Holdings
                                    </Typography>
                                }

                                <Box component={'div'} sx={(theme: Theme) => (
                                    {

                                        border: loading ? 0 : `1px solid ${theme.palette.text.secondary}B2`,
                                        borderRadius: '55px',
                                        mb: '45px'

                                    }
                                )}>
                                    {loading ? <Box sx={{ display: 'flex' }}>
                                        <Skeleton animation="wave" variant='rectangular' width={'100%'} height={'30px'} sx={{ borderRadius: '55px', mr: '10px' }} />
                                        <Skeleton animation="wave" variant='rectangular' width={'100%'} height={'30px'} sx={{ borderRadius: '55px' }} />
                                    </Box> :
                                        <Tabs
                                            value={value}
                                            onChange={() => handleChange(value === 0 ? 1 : 0)}
                                            variant="fullWidth"
                                            aria-label="Customized tabs example"
                                            sx={{

                                                '& .MuiTabs-indicator': {
                                                    display: 'none'
                                                }
                                            }}
                                        >
                                            <Tab
                                                label={<Typography variant='body_500' sx={(theme: Theme) => (
                                                    {
                                                        color: value === 0 ? theme.palette.common.white : theme.palette.text.secondary,
                                                        fontSize: '18px',
                                                        textTransform: 'capitalize'
                                                    }
                                                )}>{`${fundDetails?.holdings?.[0]?.categoryType ?? ""} ${fundDetails?.holdings?.[0]?.categoryPercentage > 0 ? !Number.isNaN(Number(fundDetails?.holdings?.[0]?.categoryPercentage ?? 0)) ?
                                                    Math.round((fundDetails?.holdings?.[0]?.categoryPercentage ?? 0) * 100) / 100 : '0' : 0}%`}</Typography>}
                                                sx={(theme: Theme) => (
                                                    {
                                                        backgroundColor: value === 0 ? theme.palette.primary[500] : theme.palette.common.white,
                                                        borderRadius: "55px",

                                                    }
                                                )}
                                            />
                                            <Tab
                                                label={<Typography variant='body_500' sx={(theme: Theme) => (
                                                    {
                                                        color: value === 1 ? theme.palette.common.white : theme.palette.text.secondary,
                                                        fontSize: '18px',
                                                        textTransform: 'capitalize'
                                                    }
                                                )}>
                                                    {`${fundDetails?.holdings?.[1]?.categoryType ?? ""} ${fundDetails?.holdings?.[1]?.categoryPercentage > 0 ? !Number.isNaN(Number(fundDetails?.holdings?.[1]?.categoryPercentage ?? 0))
                                                        ?
                                                        Math.round((fundDetails?.holdings?.[1]?.categoryPercentage ?? 0) * 100) / 100 : '0'
                                                        : 0}%`
                                                    }
                                                </Typography>
                                                }
                                                sx={(theme: Theme) => (
                                                    {
                                                        backgroundColor: value === 1 ? theme.palette.primary[500] : theme.palette.common.white,
                                                        fontSize: '18px',
                                                        borderRadius: "55px",
                                                    }
                                                )}
                                            />
                                        </Tabs>}
                                </Box>
                                {loading ? <>
                                    <Box sx={{ display: 'flex' }}>
                                        <Skeleton animation="wave" variant='rectangular' width={'20%'} height={'30px'} sx={{ mr: '5px' }} />
                                        <Skeleton animation="wave" variant='rectangular' width={'20%'} height={'30px'} sx={{ mr: '5px' }} />
                                    </Box>
                                </> : <Box component={'section'} sx={{ mb: '45px' }}>

                                    <Box component={'div'} sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.grey[200]}`, display: 'flex', flexDirection: 'row', gap: '10px' })}>
                                        <Button
                                            variant={selectedTab === 'companies' ? 'contained' : 'outlined'}
                                            onClick={() => setSelectedTab('companies')}
                                            sx={(theme: Theme) => ({
                                                padding: { xs: '10px 20px', sm: '5px 15px' }, borderRadius: '7px 7px 0 0', mr: '6px', border: 'none', cursor: 'pointer', background: selectedTab === 'companies' ? theme.palette.primary[500] : theme.palette.grey[50], '&:hover': {
                                                    border: 'none',

                                                },
                                            })}

                                        >
                                            <Typography variant='body_500' sx={(theme: Theme) => ({
                                                color: selectedTab === 'companies' ? theme.palette.common.white : theme.palette.text.secondary
                                            })}>Companies</Typography>
                                        </Button>
                                        <Button
                                            variant={selectedTab === 'sectors' ? 'contained' : 'outlined'}
                                            onClick={() => setSelectedTab('sectors')}
                                            sx={(theme: Theme) => ({
                                                padding: { xs: '10px 20px', sm: '5px 15px' }, borderRadius: '7px 7px 0 0', border: 'none', cursor: 'pointer', background: selectedTab === 'sectors' ? theme.palette.primary[500] : theme.palette.grey[50], '&:hover': {
                                                    border: 'none',

                                                },
                                            })}
                                        >
                                            <Typography variant='body_500' sx={(theme: Theme) => ({
                                                color: selectedTab === 'sectors' ? theme.palette.common.white : theme.palette.text.secondary,

                                            })}>Sectors</Typography>
                                        </Button>
                                    </Box>
                                </Box>}

                                <Box component={'section'}>
                                    {value === 0 && (selectedTab === 'companies' ? (
                                        <CompaniesTable data={showAllCompanies ? fundDetails?.holdings?.[0]?.companies : fundDetails?.holdings?.[0]?.companies?.slice(0, 5)} showAll={showAllCompanies} onShowAllToggle={handleShowAllCompaniesToggle} loading={loading} />
                                    ) : (
                                        <SectorsTable data={showAllCompanies ? fundDetails?.holdings?.[0]?.sectors : fundDetails?.holdings?.[0]?.sectors?.slice(0, 5)} showAll={showAllCompanies} onShowAllToggle={handleShowAllCompaniesToggle} loading={loading} />
                                    ))}
                                    {value === 1 && (selectedTab === 'companies' ? (
                                        <CompaniesTable data={showAllCompanies ? fundDetails?.holdings?.[1]?.companies : fundDetails?.holdings?.[1]?.companies?.slice(0, 5)} showAll={showAllCompanies} onShowAllToggle={handleShowAllCompaniesToggle} loading={loading} />
                                    ) : (
                                        <SectorsTable data={showAllCompanies ? fundDetails?.holdings?.[1]?.sectors : fundDetails?.holdings?.[1]?.sectors?.slice(0, 5)} showAll={showAllCompanies} onShowAllToggle={handleShowAllCompaniesToggle} loading={loading} />))}

                                </Box>

                            </Box>

                            <Box component={'section'} sx={(theme: Theme) => (
                                { padding: '35px 30px', borderRadius: '20px', background: theme.palette.common.white, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)' }
                            )}>
                                {loading ? <Skeleton animation="wave" width={'30%'} /> : <Typography variant='h2' sx={(theme: Theme) => ({ color: theme.palette.text.primary, letterSpacing: '0.01px', mb: '35px' })}>Fund Management</Typography>}

                                <Box component={'div'}>
                                    {fundDetails?.fundManagers?.map((fundManager: FundManagerProps, index: number) => (
                                        <React.Fragment key={index}>
                                            <FundManagerDetails key={index} fundManager={fundManager} loading={loading} />
                                            {fundDetails?.fundManagers?.length && index !== fundDetails?.fundManagers?.length - 1 && <hr />}
                                        </React.Fragment>
                                    ))}
                                </Box>
                            </Box>

                            <Box
                                component={'button'}
                                sx={{
                                    width: "100%", padding: '20px', background: theme.palette.common.white, display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2, borderRadius: '15px', cursor: 'pointer', border: 'none'
                                }}
                                onClick={() => setMoreFundInfo(!moreFundInfo)}
                            >
                                <Typography variant='h2' sx={(theme: Theme) => ({ color: theme.palette.text.primary, letterSpacing: '0.01px' })}>More Fund Info</Typography>
                                <ChevronRight />
                            </Box>
                        </>
                    )}
                    {isNFOSelected && (
                        <Box
                            sx={(theme: Theme) => ({
                                padding: '15px 20px',
                                borderRadius: '20px',
                                background: theme.palette.common.white,
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: { xs: '10px', sm: 0 }
                            })}
                        >
                            <KeyValue
                                title={'NFO Start Date'}
                                description={fundDetails?.issueOpen ? dayjs(fundDetails?.issueOpen).format('DD/MM/YYYY') : "-"}
                                loading={loading}
                            />
                            <KeyValue
                                title={'NFO End Date'}
                                description={fundDetails?.issueStatedClose ? dayjs(fundDetails?.issueStatedClose).format('DD/MM/YYYY') : "-"}
                                loading={loading}
                            />
                        </Box>
                    )}
                </Grid>

                {/* Overview */}
                {!pathName.includes('product') && (
                    <Grid item xs={12} lg={4} sx={{ mb: { xs: '25px', lg: '0' } }}>
                        <div style={{ position: 'sticky', top: 0 }}>
                            <Box component={'section'} sx={(theme: Theme) => (
                                { padding: '15px', borderRadius: '20px', background: theme.palette.common.white, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)' }
                            )}>
                                <Formik
                                    innerRef={formikRef}
                                    initialValues={values}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                    enableReinitialize
                                >
                                    {({ values, setFieldValue, handleSubmit, errors }) => {
                                        return (
                                            <Box
                                                component="form"
                                                onSubmit={handleSubmit}
                                            >   <Box sx={{
                                                mb: 7
                                            }}>
                                                    <Box
                                                        role="tablist"
                                                        sx={{ borderBottom: `1px solid ${theme.palette.text.secondary}99`, display: 'flex', flexDirection: 'row', gap: { xs: '20px', sm: '10px' } }}>
                                                        {tabList.map((item, index) => (
                                                            <Button
                                                                key={index + item?.label}
                                                                id={`fund-tab-${item?.key}`}
                                                                role="tab"
                                                                aria-selected={values?.activeTab === item?.key}
                                                                aria-controls="fund-tabpanel"
                                                                onClick={() => {
                                                                    setFieldValue('activeTab', item?.key);
                                                                    // setFieldValue('sip.sipAmount', '');
                                                                    // setFieldValue('lumpSum.lumpSumAmount', '');
                                                                }}
                                                                sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    gap: '10px',
                                                                    background: values?.activeTab === item?.key ? theme.palette.primary[500] : theme.palette.grey[50],
                                                                    borderRadius: '7px 7px 0px 0px',
                                                                    padding: { sm: '5px 15px', xs: '10px 20px' },
                                                                    cursor: 'pointer',
                                                                    minWidth: 'unset',
                                                                    '&:hover': {
                                                                        background: values?.activeTab === item?.key ? theme.palette.primary[500] : theme.palette.grey[100],
                                                                    },
                                                                }}>
                                                                <Typography
                                                                    color={values?.activeTab === item?.key ? theme.palette.textDark.primary : theme.palette.text.secondary}
                                                                    variant='subtitle_500'
                                                                >
                                                                    {item?.label}
                                                                </Typography>
                                                            </Button>
                                                        ))}
                                                    </Box>
                                                    <Grid
                                                        id="fund-tabpanel"
                                                        role="tabpanel"
                                                        aria-labelledby={`fund-tab-${values?.activeTab}`}
                                                        container rowSpacing={3} mt={0}>
                                                        {values?.activeTab === 'sip' && (
                                                            <>
                                                                <Grid container item xs={12}
                                                                    sx={(theme: Theme) => ({
                                                                        display: 'flex',
                                                                        flexDirection: 'row',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center'
                                                                    })}
                                                                >
                                                                    <Grid item xs={12} sm={5}>
                                                                        <Typography variant='body_500' sx={(theme: Theme) => ({
                                                                            color: theme.palette.text.primary,
                                                                            letterSpacing: '0.01px',
                                                                            alignSelf: 'centre'
                                                                        })}>SIP Amount</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={7}>
                                                                        <PickUpInput
                                                                            disabled={loading}
                                                                            label=""
                                                                            inputType="number"
                                                                            isLoading={loading}
                                                                            name={`sip.sipAmount`}
                                                                            minText={false}
                                                                            currencyToWords={false}
                                                                            lakhCroreInput={false}
                                                                            labelAllowed={false}

                                                                            // minValue={sipMinAmount('minimumInstallmentAmount', values?.fund[id]?.sip?.periods)}
                                                                            onValueChange={(e) => handleOnChange(e)}
                                                                        />
                                                                        {!loading && (
                                                                            <Typography variant='overline_400'>
                                                                                {`Min. Amount: ${formikRef?.current?.values?.sip?.minSip}`}
                                                                            </Typography>
                                                                        )}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid container item xs={12}
                                                                    sx={(theme: Theme) => ({
                                                                        display: 'flex',
                                                                        flexDirection: 'row',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center'
                                                                    })}>
                                                                    <Grid item xs={12} sm={5}>
                                                                        <Typography variant='body_500' sx={(theme: Theme) => ({
                                                                            color: theme.palette.text.primary, letterSpacing: '0.01px',
                                                                            alignSelf: 'centre'
                                                                        })}>Next SIP Date</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={7}>
                                                                        <CustomeBlueDatePicker
                                                                            disabled={loading}
                                                                            name={`sip.sipDate`}
                                                                            isLoading={loading}
                                                                            label=' '
                                                                            iconPositionStart={true}
                                                                            disablePast={true}
                                                                            shouldDisableDate={(date: dayjs.Dayjs) => handleDateValidation(values?.sip?.validationDates, date, true, FUND_DETAILS_FREQUENCY)}
                                                                            minDate={dayjs().add(2, 'days')}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </>
                                                        )}
                                                        {values?.activeTab === 'lumpsum' && (
                                                            <>
                                                                <Grid container item xs={12}
                                                                    sx={(theme: Theme) => ({
                                                                        display: 'flex',
                                                                        flexDirection: 'row',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center'
                                                                    })}
                                                                >
                                                                    <Grid item xs={12} sm={6}>
                                                                        <Typography variant='body_500' sx={(theme: Theme) => ({
                                                                            color: theme.palette.text.primary,
                                                                            letterSpacing: '0.01px',
                                                                            alignSelf: 'centre'
                                                                        })}>Amount</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6}>
                                                                        <PickUpInput
                                                                            disabled={loading}
                                                                            label=""
                                                                            inputType="number"
                                                                            isLoading={loading}
                                                                            name={`lumpSum.lumpSumAmount`}
                                                                            minText={false}
                                                                            currencyToWords={false}
                                                                            lakhCroreInput={false}
                                                                            labelAllowed={false}
                                                                        />
                                                                        {!loading && (
                                                                            <Typography variant='overline_400'>
                                                                                {`Min. Amount: ${formikRef?.current?.values?.lumpSum?.minimumLumpsum}`}
                                                                            </Typography>
                                                                        )}
                                                                    </Grid>
                                                                </Grid>
                                                            </>
                                                        )}
                                                    </Grid>
                                                </Box>
                                                {/* {values.activeTab === 'sip' && !loading && (
                                                    <Typography
                                                        variant='overline_400'
                                                        color='text.secondary'
                                                        textAlign={'center'}
                                                    >
                                                        {`Next SIP Installment on ${dayjs(values?.sip?.sipDate).add(1, 'month').format('DD MMMM YYYY')}`}
                                                    </Typography>
                                                )} */}
                                                <hr />
                                                {values?.activeTab?.toLowerCase() === 'sip' && Number(values?.sip?.sipAmount) >= Number(values?.sip?.minSip) && (
                                                    <>
                                                        {isMandateLoading || loading ? (
                                                            <Skeleton variant="rectangular" width="100%" height={20} />
                                                        ) : !activeMandList?.length ? (
                                                            <Box sx={{ display: 'flex', gap: '5px' }}>
                                                                <InfoIconOutlined />
                                                                <Typography variant="overline_400" color="text.secondary">
                                                                    Mandate not present for this amount. Please click proceed to continue
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                    </>
                                                )}
                                                {!pathName.includes('/product') && (
                                                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                                                        <Grid container item xs={12} spacing={{ xs: 2, sm: 3 }}>
                                                            {(values?.activeTab === 'sip' && (Number(values?.sip?.sipAmount ?? 0) < Number(values?.sip?.minSip ?? 0) || Object.keys(values?.mandate ?? {}).length === 0)) ? (
                                                                <Grid item xs={12}>
                                                                    <LoadingButton
                                                                        loading={loading || isMandateLoading}
                                                                        fullWidth
                                                                        type='submit'
                                                                        variant='contained'
                                                                        value="proceed"
                                                                        onClick={() => setFieldValue('submitAction', 'proceed')}
                                                                        sx={(theme: Theme) => ({
                                                                            ...theme.typography.body_500,
                                                                            color: 'common.white',
                                                                            padding: { xs: "12px 24px", sm: "7px 20px" },
                                                                            fontSize: { xs: '22px', sm: '20px', md: '20px', lg: '25px' },
                                                                        })}
                                                                    >
                                                                        Proceed
                                                                    </LoadingButton>
                                                                </Grid>
                                                            ) :
                                                                (
                                                                    <>
                                                                        <Grid item xs={6} sm={6}>
                                                                            <LoadingButton
                                                                                loading={loading || isMandateLoading || (values?.submitAction === 'cart' && riskPflChkLoading) || (values?.submitAction === 'cart' && apiLoading)}
                                                                                fullWidth
                                                                                type='submit'
                                                                                variant='outlined'
                                                                                value="cart"
                                                                                onClick={() => setFieldValue('submitAction', 'cart')}
                                                                                sx={(theme: Theme) => ({
                                                                                    padding: { xs: "12px 24px", sm: "5px 10px" },
                                                                                    fontSize: { xs: '22px', sm: '20px', md: '20px', lg: '25px' },
                                                                                    color: 'primary.main',
                                                                                    ...theme.typography.body_500
                                                                                })}
                                                                            >
                                                                                {USER_ROLES.INVESTOR === role ? 'Add to Cart' : 'Recommend'}
                                                                            </LoadingButton>
                                                                        </Grid>
                                                                        <Grid item xs={6} sm={6}>
                                                                            <LoadingButton
                                                                                loading={loading || isMandateLoading || (values?.submitAction === 'order' && riskPflChkLoading) || (values?.submitAction === 'order' && apiLoading)}
                                                                                fullWidth
                                                                                type='submit'
                                                                                variant='contained'
                                                                                value="order"
                                                                                onClick={() => setFieldValue('submitAction', 'order')}
                                                                                sx={{
                                                                                    padding: { xs: "12px 24px", sm: "7px 20px" },
                                                                                    fontSize: { xs: '22px', sm: '20px', md: '20px', lg: '25px' },
                                                                                    ...theme.typography.body_500
                                                                                }}
                                                                            >
                                                                                {role === USER_ROLES.INVESTOR ? values?.activeTab === 'sip' ? 'Start SIP' : 'Invest' : 'Place Order'}
                                                                            </LoadingButton>
                                                                        </Grid>
                                                                    </>
                                                                )}
                                                        </Grid>
                                                    </Box>
                                                )
                                                }
                                            </Box>
                                        )
                                    }}
                                </Formik>
                            </Box>
                        </div>
                    </Grid >
                )
                }
            </Grid >

            <Dialog
                open={moreFundInfo}
                onClose={() => setMoreFundInfo(false)}
            >
                <DialogContent>
                    <Box sx={(theme: Theme) => ({ padding: '35px 30px', mt: 2 })}>
                        <Grid container rowSpacing={3}>
                            <Grid container rowSpacing={3}>
                                {/* Ratio/Load rows mapped */}
                                {/* {DETAIL_ROWS.map((row) => (
                                    <Grid item xs={12} key={row.key}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '7px' }}>
                                                <Typography component="span" variant="subtitle_500" sx={{ color: 'text.primary', letterSpacing: '0.02px' }}>
                                                    {row.label}
                                                </Typography>
                                                <Tooltip
                                                    slotProps={{ tooltip: { sx: { margin: 0, backgroundColor: 'transparent' } } }}
                                                    title={
                                                        <Box sx={{ borderRadius: 2, background: '#0F131F', p: 2 }}>
                                                            <span style={{ ...theme.typography.subtitle_500, fontFamily: theme.typography.fontFamily }}>
                                                                {row.tooltip}
                                                            </span>
                                                        </Box>
                                                    }
                                                >
                                                    <IconButton>
                                                        <InfoIconOutlined />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                            <Typography variant={row.getVariant(row.value)} sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                                                {row.displayValue}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))} */}

                                {/* Document rows mapped */}
                                {DOC_ROWS.map((doc) => (
                                    <Grid item xs={12} key={doc.key}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                            <Typography component="span" variant="subtitle_500"
                                                sx={{ color: 'text.primary', letterSpacing: '0.02px', maxWidth: '150px', flexWrap: 'wrap' }}
                                            >
                                                {doc.label}
                                            </Typography>
                                            {doc.check ? vrLoading[doc.key as keyof typeof vrLoading] ? (
                                                <CircularProgress size={20} />
                                            ) :
                                                (
                                                    <Button
                                                        variant="text"
                                                        onClick={doc.onClick}
                                                        sx={{
                                                            color: theme.palette.customColors.hyperlinkBlue,
                                                            textDecoration: 'underline',
                                                            textAlign: 'right',
                                                            fontSize: '14px',
                                                            padding: 0,
                                                            minWidth: 0,
                                                            margin: 0,
                                                            lineHeight: 1,
                                                            '&:hover': {
                                                                border: 'none',
                                                                background: 'transparent'
                                                            }
                                                        }}
                                                    >
                                                        {doc.key.toUpperCase()}
                                                    </Button>
                                                )
                                                : (
                                                    <Typography variant="overline_400">Please refer to factsheet</Typography>
                                                )
                                            }
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* OTP Dialog */}
            <Dialog
                open={isOtpDialogOpen}
                onClose={() => setOtpDialogOpen(false)}
                maxWidth="sm"
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        flexDirection: "column",
                        rowGap: "24px"
                    }
                })}
            >
                <Typography
                    component="span"
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        lineHeight: "24px",
                        letterSpacing: "0.02px",
                        color: theme.palette.customColors.hyperlinkBlue,
                        textAlign: "center"
                    })}
                >
                    {otpDialogData?.otp_response?.message ?? ""}
                </Typography>
                <OTPForm
                    onSubmit={() => { return; }}
                    onResend={() => { return; }}
                    otpMessage=""
                    warningMessage=""
                />
            </Dialog>
            {
                cartPopup &&
                <AddtoCardPopup
                    open={cartPopup}
                    setClose={setCartPopup}
                    handleSuccess={handleAddToCart}
                />
            }
            <ValidateDialogBox
                handleValidationDialogClose={() => setValidationDialogVisible(false)}
                validationErrorsArray={validationErrorsArray}
                isValidationDialogVisible={isValidationDialogVisible}
            />
            <SuccessModal
                open={successModal}
                setClose={setSuccessModal}
                onclick={handleSuccessPopup}
                title="Success!"
                confirmBtnText={"Go to Dashboard"}
                desc={fetchSuccessMsg()}
            />
            <ConfirmRecomment
                isLoading={apiLoading}
                open={confirmRecomment}
                setClose={setConfirmRecomment}
                title={(formikRef?.current?.values?.submitAction?.toLowerCase() === 'cart' && isRMLikeRole(role)) ? "Confirm Recommendation!" : (formikRef?.current?.values?.submitAction?.toLowerCase() === 'order' && isRMLikeRole(role)) ? "Confirm!" : ''}
                desc={(formikRef?.current?.values?.submitAction?.toLowerCase() === 'cart' && isRMLikeRole(role)) ? "Are you sure you want to continue with this action ? You can see your old recommendations under recent recommendation tab." : "Are you sure you want to continue with this action ?"}
                handleConfirm={() => (formikRef?.current?.values?.submitAction?.toLowerCase() === 'cart' && isRMLikeRole(role)) ? handleConfirmRecommend(formikRef?.current?.values) : handleConfirmOrder(formikRef?.current?.values ?? {} as FormikValues)}
            />
            <RiskProfilePopup open={riskProfilePopup} setClose={handleRiskProfilePopup} handleConfirmOrder={handleConfirmOrder} isLoading={apiLoading} text={riskPopupText} />

            <FiveSchemeErrorMessage handleCloseFiveSchemesDialog={() => setFiveSchemesDialogVisible(false)} isFiveSchemesDialogVisible={isFiveSchemesDialogVisible} />
        </>

    )
}
